var exports = {
  "an": "ErrorFallback.module__errorFallbackContainer___NWdHYz",
  "MU": "ErrorFallback.module__errorFallbackIcon___NWdHYz",
  "S6": "ErrorFallback.module__errorFallbackContent___NWdHYz",
  "jQ": "ErrorFallback.module__errorFallbackTitle___NWdHYz",
  "pF": "ErrorFallback.module__errorFallbackDescription___NWdHYz",
  "sM": "ErrorFallback.module__errorFallbackActions___NWdHYz",
};

module.exports = exports;
